import { Cluster } from '@googlemaps/markerclusterer';

const ClusterRenderer = {
  render: ({ count, position }: Cluster): google.maps.Marker => {
    const defaultClusterIcon = {
      url: '/img/maps/address-marker-cluster.svg',
      scaledSize: new google.maps.Size(48, 48),
      labelOrigin: new google.maps.Point(24, 24),
    };
    const activeClusterIcon = {
      url: '/img/maps/address-marker-active-cluster.svg',
      scaledSize: new google.maps.Size(48, 48),
      labelOrigin: new google.maps.Point(24, 24),
    };

    const clusterMarker = new google.maps.Marker({
      label: {
        text: String(count),
        color: 'white',
        fontFamily: 'Bauhaus',
        fontSize: '18px',
        fontWeight: '600',
      },
      position,
      icon: defaultClusterIcon,
      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });

    const mouseOver = google.maps.event.addListener(clusterMarker, 'mouseover', () => {
      clusterMarker.setIcon(activeClusterIcon);
    });

    const mouseOut = google.maps.event.addListener(clusterMarker, 'mouseout', () => {
      clusterMarker.setIcon(defaultClusterIcon);
    });

    google.maps.event.addListener(clusterMarker, 'click', () => {
      clusterMarker.setIcon(defaultClusterIcon);
    });

    return clusterMarker;
  },
};

export default ClusterRenderer;
